"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconPosition = void 0;
exports.getIconPosition = function (size, breakpoints) {
    // If the size is already in the list we return its position.
    var exactMatch = breakpoints.indexOf(size);
    if (exactMatch !== -1) {
        return exactMatch;
    }
    var biggerIndex = breakpoints.findIndex(function (item) { return item >= size; });
    var smallerIndex = biggerIndex - 1;
    // If the size is located between two numbers we return the position of smaller number.
    if (biggerIndex !== -1 && smallerIndex !== -1) {
        return smallerIndex;
    }
    var lastIndex = breakpoints.length - 1;
    // If the size is bigger than the biggest number in the list we return the position of the last number in the list.
    if (size > breakpoints[lastIndex]) {
        return lastIndex;
    }
    // In all other cases we return 0 as fallback.
    return 0;
};
